import { collector } from "../collector";

// Global JS errors, unhandled promise rejections, console.error tee, and
// resource-load failures (failed camera stream / model asset / image).
export function startErrors() {
  const onError = (e) => {
    collector.track("js_error", {
      message: e.message,
      source: e.filename,
      line: e.lineno,
      col: e.colno,
      stack: e.error && e.error.stack,
    });
  };

  const onRejection = (e) => {
    const r = e.reason;
    collector.track("unhandled_rejection", {
      message: (r && (r.message || String(r))) || "unknown",
      stack: r && r.stack,
    });
  };

  // Resource errors don't bubble — capture phase catches them.
  const onResourceError = (e) => {
    const t = e.target;
    if (!t || !t.tagName) return;
    if (["IMG", "SCRIPT", "LINK", "VIDEO", "AUDIO", "SOURCE"].includes(t.tagName)) {
      collector.track("resource_error", { tag: t.tagName.toLowerCase(), src: t.src || t.href || null });
    }
  };

  const origConsoleError = console.error;
  const teedConsoleError = function (...args) {
    try {
      collector.track("console_error", {
        args: args
          .slice(0, 5)
          .map((a) => (typeof a === "string" ? a : a && a.message ? a.message : String(a))),
      });
    } catch (err) {
      /* never break console */
    }
    return origConsoleError.apply(this, args);
  };

  window.addEventListener("error", onError);
  window.addEventListener("unhandledrejection", onRejection);
  window.addEventListener("error", onResourceError, true);
  console.error = teedConsoleError;

  return () => {
    window.removeEventListener("error", onError);
    window.removeEventListener("unhandledrejection", onRejection);
    window.removeEventListener("error", onResourceError, true);
    if (console.error === teedConsoleError) console.error = origConsoleError;
  };
}
